import React from 'react'
import classNames from 'classnames'

export default function ProgressBarStep ({ text, active = false, hasLine = true, current = false, previous = false }) {
  return (
    <>
      <div className={classNames({
        'progress-bar__step': true,
        'progress-bar__step--active': active,
        'progress-bar__step--animate': current,
      })}>
        <span className="progress-bar__step-text">{text}</span>
      </div>
      {hasLine && <span className={classNames({
        'progress-bar__line': true,
        'progress-bar__line--active': active && !current,
        'progress-bar__line--animate': previous
      })}></span>}
    </>
  )
}